import { render, staticRenderFns } from "./DemandaContratadaPontaField.vue?vue&type=template&id=473c12b2&scoped=true&"
import script from "./DemandaContratadaPontaField.vue?vue&type=script&lang=js&"
export * from "./DemandaContratadaPontaField.vue?vue&type=script&lang=js&"
import style0 from "./DemandaContratadaPontaField.vue?vue&type=style&index=0&id=473c12b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473c12b2",
  null
  
)

export default component.exports